import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const Display = (props) => {
  const { title, subtitle, content, image, reverse } = props;
  return (
    <StyledSection>
      <Wrapper reverse={reverse}>
        <ContentWrapper>
          <Subtitle>{subtitle}</Subtitle>
          <Title>{title}</Title>
          <Content>{content}</Content>
        </ContentWrapper>
        <ImageWrapper>
          <GatsbyImage
            image={image.childImageSharp.gatsbyImageData}
            alt="A screenshot of Commerce7 platform."
          />
        </ImageWrapper>
      </Wrapper>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  margin-bottom: 225px;
`;

const Wrapper = styled.div`
  ${({ theme, reverse }) => `
    @media ${theme.xLargeUp} {
      display: flex;
      flex-direction: ${reverse ? 'row-reverse' : 'row'}};
      align-items: center;
      justify-content: space-between;
    }
`}
`;

const ContentWrapper = styled.div`
  margin-bottom: 60px;
  ${({ theme }) => `
    @media ${theme.xLargeUp} {
      margin-bottom: 0px;
      width: 60%;
      max-width: 640px;
    }
`}
`;

const ImageWrapper = styled.div`
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      max-width: 700px;
      margin: auto;
    }
    @media ${theme.xLargeUp} {
      width: 75%;
      max-width: 900px;
      padding-left: 10%;
    }
`}
`;

const Subtitle = styled.h3`
  color: var(--gray-dark);
  font-size: var(--font-size-lg);
  letter-spacing: var(--letter-spacing-base);
  margin-bottom: 10px;
`;

const Title = styled.h2`
  font-size: var(--heading-size-base);
  line-height: var(--line-height-base);
  color: var(--blue-dark);
  font-weight: var(--font-weight-bold);
  margin-bottom: 30px;
`;

const Content = styled.p``;

export default Display;
